export const ACCESS_CONTROL_EVENT_FIELDS = [
	'occurred_at',
	'device_label',
	'user_label',
	'method',
	'status',
	'door_status',
	'reader_id',
	'match_route',
	'source_label',
]

const hasValue = (value) => value !== undefined && value !== null && String(value).trim() !== ''

const text = (key, translate) => typeof translate === 'function' ? translate(key) : key

const displayValue = (value, emptyLabel) => hasValue(value) ? value : emptyLabel

export const isSuccessfulAccessEvent = (event = {}) => {
	return event.code === 'AccessControl' && String(event.status) === '1'
}

export const isDoorStatusEvent = (event = {}) => {
	return event.code === 'DoorStatus' && ['Open', 'Close'].includes(event.door_status)
}

export const formatAccessControlEvent = (event = {}, translate) => {
	const emptyLabel = text('n_a', translate) || 'N/A'
	const formatted = {}

	ACCESS_CONTROL_EVENT_FIELDS.forEach((field) => {
		formatted[field] = displayValue(event[field], emptyLabel)
	})

	formatted.raw_status = event.status
	formatted.raw_snap_path = event.snap_path
	formatted.is_example = !!event.is_example
	formatted.is_successful_access = isSuccessfulAccessEvent(event)
	formatted.is_door_status = isDoorStatusEvent(event)

	if (event.code === 'AccessControl') {
		formatted.status = formatted.is_successful_access
			? text('successful_access', translate)
			: displayValue(event.status, emptyLabel)
	}

	if (event.code === 'DoorStatus') {
		if (event.door_status === 'Open') {
			formatted.door_status = text('door_open', translate)
		} else if (event.door_status === 'Close') {
			formatted.door_status = text('door_closed', translate)
		}
	}

	formatted.id = event.id || event.raw_id || [
		event.code || 'access_control',
		event.occurred_at || event.createdAt || '',
		event.user_id || '',
		event.device_sn || '',
	].join('-')
	formatted.occurred_at = displayValue(event.occurred_at || event.createdAt, emptyLabel)
	formatted.deviceId = event.deviceId
	formatted.device_label = displayValue(event.deviceId || event.device_sn || event.deviceSn, emptyLabel)
	formatted.user_label = displayValue(event.user_name || event.user_id, emptyLabel)
	formatted.match_route = displayValue(event.matched || event.route_key || event.path, emptyLabel)
	formatted.source_label = displayValue(event.source_ip || event.http_method, emptyLabel)

	return formatted
}
